import React from "react"
import { Box, Typography, Card, CardContent, Alert, Grid2, Skeleton } from "@mui/material"
import { Inventory, Inventory2, MoveToInbox } from "@mui/icons-material"
import { Stack } from "src/shared/components"
import MinimulTabs from "src/shared/components/MinimalTabs/MinimulTabs"

const LotScanningSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Header Section Skeleton */}
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Inventory color="primary" />
        <Box>
          <Skeleton variant="text" width={250} height={32} />
          <Skeleton variant="text" width={120} height={20} />
        </Box>
      </Box>

      {/* Barcode Scanner and Tabs Section Skeleton */}
      <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))" gap={2} mb={2}>
        {/* Barcode Scanner Skeleton */}
        <Box>
          <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={35} sx={{ borderRadius: 1 }} />
        </Box>

        {/* Scan Type Tabs Skeleton */}
        <Stack variant="rowCenter" spacing={2}>
          <Typography variant="body1">Scan Type:</Typography>
          <MinimulTabs
            handleTabChange={() => {}}
            gap={"0px"}
            sx={{ width: "50%", height: "40px" }}
            tabs={[
              {
                label: "Open",
                value: "OPEN",
                icon: <Inventory2 sx={{ fontSize: "16px" }} />
              },
              {
                label: "Box",
                value: "BOX",
                icon: <MoveToInbox sx={{ fontSize: "16px" }} />
              }
            ]}
            value="BOX"
          />
        </Stack>
      </Box>

      {/* Alert Section */}
      <Alert severity="info">Start scanning lots by entering lot numbers and quantities above</Alert>

      {/* Quick Overview Card Skeleton */}
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom color="primary.main">
            Quick Overview
          </Typography>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
              <Box textAlign="center">
                <Skeleton variant="text" width={60} height={40} sx={{ mx: "auto" }} />
                <Skeleton variant="text" width={120} height={20} sx={{ mx: "auto" }} />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
              <Box textAlign="center">
                <Skeleton variant="text" width={60} height={40} sx={{ mx: "auto" }} />
                <Skeleton variant="text" width={120} height={20} sx={{ mx: "auto" }} />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
              <Box textAlign="center">
                <Skeleton variant="text" width={60} height={40} sx={{ mx: "auto" }} />
                <Skeleton variant="text" width={120} height={20} sx={{ mx: "auto" }} />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
              <Box textAlign="center">
                <Skeleton variant="text" width={60} height={40} sx={{ mx: "auto" }} />
                <Skeleton variant="text" width={120} height={20} sx={{ mx: "auto" }} />
              </Box>
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>
    </Box>
  )
}

export default LotScanningSkeleton
